import React from 'react';
import { ScreeningType } from '@/enums/enums';

interface SelectAnswerProps {
  type: ScreeningType.MULTIPLE_SELECT | ScreeningType.SINGLE_SELECT;
  screeningAnswers: { originalText: string; translatedText: string | null; id: string }[];
  selectedAnswers: string[];
  handleSelectAnswer: (value: string, isMultiSelect: boolean) => void;
}

function SelectAnswer({
  type,
  screeningAnswers,
  selectedAnswers,
  handleSelectAnswer,
}: SelectAnswerProps) {
  const isMultiSelect = type === ScreeningType.MULTIPLE_SELECT;
  const inputType = isMultiSelect ? 'checkbox' : 'radio';
  const containerClass = isMultiSelect
    ? 'flex mt-6 flex-col gap-3'
    : 'flex w-full mt-6 flex-col gap-3';

  return (
    <div className={containerClass}>
      {React.Children.toArray(
        screeningAnswers?.map(({ originalText, translatedText }) => (
          <label
            key={originalText}
            className="flex items-center gap-2.5 cursor-pointer w-fit text-dark-text text-gray-500 hover:text-dark-text transition-colors"
          >
            <input
              onChange={() => handleSelectAnswer(originalText, isMultiSelect)}
              checked={selectedAnswers.some((selectedAnswer) => selectedAnswer === originalText)}
              type={inputType}
              className="min-w-5 min-h-5 self-start mt-0.5 cursor-pointer"
              value={originalText}
            />
            <p className="font-medium text-sm">{translatedText || originalText}</p>
          </label>
        )),
      )}
    </div>
  );
}

export default SelectAnswer;
